import pathify from 'vuex-pathify'

// options
pathify.options.mapping = 'simple'
pathify.options.deep = 1

export default pathify
